module.exports = __webpack_public_path__ + "static/media/USPayrollChequeSample_1.6b38c3c5.png";